import Specs from './Specs';
export default Specs;
